<template>
  <div id="wrapper">
    <div id="map">
      <yandex-maps
          :coords="coords"
          :controls="controls"
          :placemarks="currentPlacemarks"
          :zoom="zoom"
          style="width: 100%; height: 100%;"
          @click-marker="setCurrentPlacemark($event)"
      />
    </div><!-- /#map -->
    <div id="list">
      <div class="filter" v-if="isReady">
        <p>
          <input type="text" v-model="filterText" placeholder="Начните вводить название..."/>
          <button v-if="filterText.length" @click="filterText = ''">X</button>
        </p>
        <p class="counter">Показано: {{ currentPlacemarks.length }} из {{ placemarks.length }}</p>
        <p class="type">
          <a href="javascript:void(0);"
             :class="currentType === 'all' ? 'active' : ''"
             @click="setCurrentType('all')">Все записи</a>
          <a href="javascript:void(0);"
             :class="currentType === 'diocese' ? 'active' : ''"
             @click="setCurrentType('diocese')">Епархии</a>
          <a href="javascript:void(0);"
             :class="currentType === 'association' ? 'active' : ''"
             @click="setCurrentType('association')">Сообщества</a>
        </p>
      </div><!-- /.filter -->
      <div id="list-wrapper" v-if="currentPlacemarks.length">
        <ul>
          <li v-for="placemark in currentPlacemarks" v-bind:key="placemark.node.nid">
            <a href="javascript:void(0);" @click="setCurrentPlacemark(placemark, true)">{{ placemark.node.title }}</a>
          </li>
        </ul>
      </div><!-- /#list-wrapper -->
      <p class="loading" v-if="!isReady">Загрузка...</p>
    </div><!-- /#list -->
    <transition name="slide">
      <div id="info" v-if="currentNode.nid">
        <div class="inner">
          <div class="title">
            <h2>{{ currentNode.title }}</h2>
            <button @click="hideInfo">X</button>
          </div><!-- /.title -->
          <div class="image">
            <img
                :src="currentNode.field_media_image"
                :alt="currentNode.title"
            />
          </div><!-- /.title -->
          <div class="bishop" v-if="currentNode.field_diocese_bishop.length">
            <h3>{{ currentNode.head_title }}</h3>
            <p>{{ currentNode.field_diocese_bishop }}</p>
          </div><!-- /.bishop -->
          <div class="contacts">
            <h3>Контакты</h3>
            <p v-html="currentNode.field_diocese_secretary"></p>
            <p class="social">
              <a target="_blank" class="fb"
                 v-if="currentNode.field_diocese_link_fb"
                 :href="currentNode.field_diocese_link_fb">FB</a>
              <a target="_blank" class="vk"
                 v-if="currentNode.field_diocese_link_vk"
                 :href="currentNode.field_diocese_link_vk">ВК</a>
              <a target="_blank" class="instagram"
                 v-if="currentNode.field_diocese_link_instagram"
                 :href="currentNode.field_diocese_link_instagram">IN</a>
              <a target="_blank" class="twitter"
                 v-if="currentNode.field_diocese_link_twitter"
                 :href="currentNode.field_diocese_link_twitter">TW</a>
              <a target="_blank" class="youtube"
                 v-if="currentNode.field_diocese_link_youtube"
                 :href="currentNode.field_diocese_link_youtube">YT</a>
            </p>
            <p class="website"><a :href="currentNode.path">Перейти на страницу {{ currentNode.type_names.r }}</a></p>
          </div><!-- /.contacts -->
          <div class="articles" v-if="currentNode.articles.length">
            <h3>Последние новости {{ currentNode.type_names.r }}</h3>
            <ul>
              <li v-for="article in currentNode.articles" v-bind:key="article.nid">
                <a :href="article.path">{{ article.title }}</a>
              </li>
            </ul>
          </div><!-- /.articles -->
        </div><!-- /.inner -->
      </div><!-- /#info -->
    </transition>
    <transition name="fade">
      <div id="loading" v-if="!isReady">
        <div class="inner">
          <p>Загрузка...</p>
        </div><!-- /.inner -->
      </div><!-- /#loading -->
    </transition>
  </div><!-- /#wrapper -->
</template>

<script>

  import axios from 'axios-jsonp-pro';
  import YandexMaps from './components/YandexMaps';

  export default {
    name: 'app',
    components: { YandexMaps },
    data () {
      return {
        isReady: false,
        coords: [61.628966, 99.731893],
        zoom: 3,
        controls: [
          'zoomControl'
        ],
        filterText: '',
        placemarks: [],
        currentPlacemark: {
          node: false,
        },
        currentType: 'all',
      };
    },
    computed: {
      currentPlacemarks () {
        return this.placemarks.filter(
          placemark => (this.currentType === 'all' || placemark.node.type === this.currentType) &&
            (!this.filterText.length ||
            placemark.node.field_diocese_city.toLowerCase().indexOf(this.filterText.toLowerCase()) !== -1 ||
            placemark.node.title.toLowerCase().indexOf(this.filterText.toLowerCase()) !== -1)
        );
      },
      currentNode () {
        return this.currentPlacemark.node;
      },
    },
    methods: {
      addPlacemark (node) {
        // const address = node.field_diocese_address
        const geo_point = node.field_diocese_geo_point;
        if (geo_point !== false) {
          // var vm = this;
          let placemark = {
            markerId: node.nid,
            node,
            coords: [geo_point.lat, geo_point.lon],
            properties: {},
            options: {},
            clusterName: '1',
          };
          this.placemarks.push(placemark);
        }
      },
      setCurrentPlacemark (placemark, resetCoords = false) {
        // @todo Открывать balloon после установки currentNode, имитируя нажатие на маркер
        if (typeof placemark.node.articles !== 'undefined') {
          this.currentPlacemark = placemark;
          this.currentPlacemark.node.field_diocese_secretary = this.currentNode.field_diocese_secretary.replace(
            /(?:\r\n|\r|\n)/g,
            '<br>');
          if (resetCoords) {
            this.coords = placemark.coords;
          }
        }
        else {
          axios
          // @todo Перенести URL в конфиг
            .jsonp(process.env.VUE_APP_DOMAIN + '/zz_iv/views/news-dioceses/' + placemark.node.nid + '/json').then(response => {
            placemark.node.articles = [];
            if (typeof response.nodes !== 'undefined' && response.nodes.length) {
              for (const k in response.nodes) {
                const article = response.nodes[k].node;
                placemark.node.articles.push(article);
              }
            }
            // @todo Дубликат кода
            this.currentPlacemark = placemark;
            this.currentPlacemark.node.field_diocese_secretary = this.currentNode.field_diocese_secretary.replace(
              /(?:\r\n|\r|\n)/g, '<br>');
            if (resetCoords) {
              this.coords = placemark.coords;
            }
          }).catch(error => {
            // @todo Добавить обработку ошибок
            console.log(error);
          });
        }
      },
      hideInfo () {
        this.currentPlacemark = { node: false };
      },
      setCurrentType(type) {
        this.currentType = type;
      },
    },
    mounted () {
      axios
      // @todo Перенести URL в конфиг
        .jsonp(process.env.VUE_APP_DOMAIN + process.env.VUE_APP_PLACES_URI).then(response => {
        if (typeof response.nodes !== 'undefined' && response.nodes.length) {
          for (const k in response.nodes) {
            const node = response.nodes[k].node;
            // Адрес
            let address = JSON.parse(node.field_diocese_address);
            node.field_diocese_address = address.address;
            node.field_diocese_geo_point = address.geo_point;
            // Свойства, специфичные для разных типов
            switch (node.type) {
              case 'diocese': {
                node.head_title = 'Правящий архиерей';
                node.type_names = {
                  i: 'епархия',
                  r: 'епархии',
                };
                node.placemark_color = 'red';
                break;
              }
              case 'association': {
                node.head_title = 'Руководитель';
                node.type_names = {
                  i: 'сообщество',
                  r: 'сообщества',
                };
                node.placemark_color = 'green';
                break;
              }
            }
            this.addPlacemark(node);
          }
          this.isReady = true;
        }
      }).catch(error => {
        console.log(error);
      });
    },
  };
</script>

<style>

  html,
  body {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #333333;
  }

  #wrapper {
    position: relative;
    overflow: hidden;
  }

  #map {
    height: 100vh;
    margin-right: 320px;
  }

  #list {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #ddd;
    width: 320px;
    /* border-left: 3px solid #c4007a; */
    -webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .3);
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .3);
  }

  #list .filter {
    height: 100px;
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #aaa;
    position: relative;
  }

  #list .filter input {
    border: 1px solid #ccc;
    background-color: #ffffff;
    padding: 9px;
    width: 280px;
    font-size: 16px;
  }

  #list .filter button {
    position: absolute;
    top: 31px;
    right: 20px;
    background: none;
    border: 1px solid #ccc;
    width: 16px;
    height: 16px;
    line-height: 10px;
    text-align: center;
    border-radius: 50%;
    font-size: 9px;
    color: #cccccc;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;
    cursor: pointer;
  }

  #list .filter p {
    font-size: 12px;
    color: #777777;
    margin: 0;
  }

  #list .filter p.counter {
    padding-left: 10px;
    margin-top: 3px;
  }

  #list .filter p.type {
    margin: 0;
    margin-top: 10px;
  }

  #list .filter p.type a {
    color: #c4007a;
    text-decoration: none;
    border-bottom: 1px dashed;
    margin-left: 10px;
  }

  #list .filter p.type a.active {
    color: #000;
    border-bottom: none;
  }

  #list ul,
  #list ul li {
    margin: 0;
    padding: 0;
    list-style: none none;
  }

  #list-wrapper {
    overflow-y: scroll;
    height: calc(100vh - 100px);
  }

  #list ul li {
    background-color: #ffffff;
    border-bottom: 1px solid #ccc;
  }

  #list ul li a {
    display: block;
    padding: 10px 20px;
    text-decoration: none;
    color: #c4007a;
  }

  #list ul li a:hover {
    color: #a60067;
    background-color: #f0f0f0;
    -webkit-transition: background-color 200ms linear;
    -ms-transition: background-color 200ms linear;
    transition: background-color 200ms linear;
  }

  #list .loading {
    margin: 0;
    padding: 0;
    text-align: center;
    height: 100vh;
    line-height: 100vh;
    font-size: 16px;
  }

  #info {
    position: absolute;
    right: 0;
    top: 0;
    height: 100vh;
    overflow: auto;
    background-color: #fff;
    width: 320px;
  }

  #info .inner {
    padding: 10px;
  }

  #info .title {
    position: relative;
    padding-bottom: 10px;
  }

  #info .title h2 {
    padding-right: 25px;
    font-weight: normal;
    font-size: 20px;
    margin: 0;
  }

  #info .title button {
    position: absolute;
    top: 7px;
    right: 0;
  }

  #info .image {
    margin-left: -10px;
    margin-right: -10px;
    height: 222px;
    background-color: #eeeeee;
  }

  #info .image img {
    max-width: 100%;
  }

  #info p {
    margin: 10px 0;
  }

  #info h3 {
    font-weight: bold;
    font-size: 16px;
    margin: 10px 0;
  }

  #info p.social {
    overflow: hidden;
    margin: 15px 0;
  }

  #info p.social a {
    display: block;
    width: 24px;
    height: 24px;
    float: left;
    margin-right: 10px;
    overflow: hidden;
    text-indent: -2000px;
  }

  #info p.social a.fb {
    background: url('https://pravoslavmolodezh.ru/sites/all/themes/main/images/social/circle-fb.png') no-repeat 0 0;
    background-size: contain;
  }

  #info p.social a.vk {
    background: url('https://pravoslavmolodezh.ru/sites/all/themes/main/images/social/circle-vk.png') no-repeat 0 0;
    background-size: contain;
  }

  #info p.social a.instagram {
    background: url('https://pravoslavmolodezh.ru/sites/all/themes/main/images/social/circle-instagram.png') no-repeat 0 0;
    background-size: contain;
  }

  #info p.social a.twitter {
    background: url('https://pravoslavmolodezh.ru/sites/all/themes/main/images/social/circle-twitter.png') no-repeat 0 0;
    background-size: contain;
  }

  #info p.social a.youtube {
    background: url('https://pravoslavmolodezh.ru/sites/all/themes/main/images/social/circle-youtube.png') no-repeat 0 0;
    background-size: contain;
  }

  #info p.website {
  }

  #info p.website a {
    display: block;
    background-color: #c4007a;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    padding: 7px 0;
  }

  #info p.website a:hover {
    background-color: #a60067;
    -webkit-transition: background-color 200ms linear;
    -ms-transition: background-color 200ms linear;
    transition: background-color 200ms linear;
  }

  #info .articles {
    margin-top: 20px;
  }

  #info .articles ul,
  #info .articles ul li {
    margin: 0;
    padding: 0;
    list-style: none none;
  }

  #info .articles ul li {
    margin: 10px 0;
  }

  #info .articles ul li a {
    color: #c4007a;
    text-decoration: none;
  }

  #info .articles ul li a:hover {
    color: #a60067;
  }

  #loading {
    position: fixed;
    left: 50%;
    top: 50%;
  }

  #loading .inner {
    background-color: #fff;
    width: 200px;
    height: 50px;
    margin-left: -260px; /* (200/2) + (320/2) */
    margin-top: -25px;
    -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.4);
    box-shadow: 0 0 30px 0 rgba(0,0,0,.4);
    border-radius: 10px;
  }

  #loading .inner p {
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 768px) {

    #map {
      margin-right: 0;
    }

    #list {
      height: 110px;
      top: auto;
      bottom: 0;
      width: 100%;
    }

    #list-wrapper {
      display: none;
    }

    #list .filter input {
      width: calc(100% - 20px);
    }

    #list .filter p.type {
      margin-top: 5px;
    }

    #info {
      width: 100%;
    }

  }

</style>